import * as React from 'react'
import { BlockWithChildren, EventBlock } from '@basehub/data/replicache/index'
import { TimeSeries } from './time-series'
import { BlockVariant } from '..'
import { Table } from './table'
import { BlockLabelMoreActionsPortal } from '../block-wrapper'
import { ButtonLink } from '~/sotano-kit/primitives/button'
import { idToSourceBlockId } from '@basehub/data/replicache/mutators/repo-space/block/mutators/copy-on-write'
import { useRepoReplicache } from '~/hooks-data/use-repo-replicache'
import { DownloadIcon } from '@radix-ui/react-icons'
import { useIsEditorOrHigher } from '~/hooks-data/use-user-role'

export const EventBlockInput = ({
  block,
  variant,
  path,
  parentBlock,
}: {
  block: EventBlock
  variant?: BlockVariant
  path: string
  parentBlock: BlockWithChildren
}) => {
  const { team, repoId } = useRepoReplicache().data ?? {}
  const blockId = idToSourceBlockId(block)
  const isEditorOrHigher = useIsEditorOrHigher()

  const CSVDownloadURL = React.useMemo(() => {
    // this was used for getting just the current keys
    // but i think we should just give the user all the keys
    // and they can remove the ones they don't need in Sheets.
    // const keys = encodeURIComponent(
    //   Object.values(block.constraints.schema)
    //     .map((c) => c?.name)
    //     .filter(Boolean)
    //     .join(',')
    // )

    return `/api/v2/events/export?block-id=${blockId}&repo-id=${repoId}&team-id=${team?.id}&block-title=${block.title}`
  }, [block.title, blockId, repoId, team?.id])

  if (!isEditorOrHigher) {
    return (
      <div className="border border-dark-border-solid bg-dark-base-dark rounded-lg flex flex-col items-center justify-center h-32 gap-y-2">
        <p className="text-sm font-medium text-dark-faint max-w-lg text-center">
          You need editor permissions or higher to view Event Block data.
        </p>
      </div>
    )
  }
  return (
    <>
      <BlockLabelMoreActionsPortal blockId={block.id}>
        <ButtonLink
          unstyled
          focusStyled
          className="cursor-default text-xs font-medium transition-colors hover:text-dark-bright text-dark-muted flex items-center gap-x-1 mr-1"
          href={CSVDownloadURL}
          target="_blank"
        >
          <DownloadIcon className="size-[0.9375rem]" />
          <span>Download CSV</span>
        </ButtonLink>
      </BlockLabelMoreActionsPortal>
      {block.typeOptions.view === 'chart' && (
        <TimeSeries block={block} parentBlock={parentBlock} />
      )}
      {block.typeOptions.view === 'table' && (
        <Table block={block} variant={variant} path={path} />
      )}
    </>
  )
}
